(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-success.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-success.js');

'use strict';

class PaymentSuccess extends svs.tur.payment.dialogs.PaymentSuccess {
  constructor(_ref) {
    let {
      products,
      recipientName,
      contactInfo,
      onConfirm
    } = _ref;
    super({});
    this.products = products;
    this.recipientName = recipientName;
    this.contactInfo = contactInfo;
    this.onConfirm = onConfirm;
  }
  getTitle() {
    return 'Ditt andelsspel är reserverat!';
  }
  getMessage() {
    const message = [];
    const fractiongamesReservedUrl = svs.core.urlMapping.get('fractiongamesReserved');
    message.push({
      type: svs.components.dialog.message.TEXT,
      text: "Du hittar det p\xE5 andelsspelsidan under <a href=".concat(fractiongamesReservedUrl, ">Reserverade spel</a>.<br />\n      Direkt n\xE4r alla andelar i spelet \xE4r s\xE5lda hamnar det i Mina spel."),
      align: svs.components.dialog.message.align.CENTER
    });
    return message;
  }
}
svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentSuccess = PaymentSuccess;

 })(window);